<template>
  <div>
    <div class="pageTitleWrap">
      <!-- <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/modules/wms/manage/delivery' }">出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="common-wrap white">
      <div style="padding: 0 10px">
        <div v-show="!showGoodsDetail" class="firstTitle">
          {{ "出库单号：" + formData.billNo }}
        </div>
        <div class="firstTitle1">基本信息配置</div>

        <el-form :rules="rules" :disabled="!showGoodsDetail" ref="form" :model="formData" label-width="80px">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="出库仓库" prop="bodyId">
                <el-col :span="8">
                  <el-select v-model="formData.bodyId" placeholder="请选择主体" @change="getMainOptions">
                    <el-option v-for="item in mainOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select v-model="formData.wsId" placeholder="请选择分仓" @change="getLocOptions">
                    <el-option v-for="(item, index) in distOptions" :label="item.label" :value="item.value" :key="index"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select v-model="formData.locId" placeholder="请选择仓位">
                    <el-option v-for="(item, index) in locOptions" :label="item.label" :value="item.value" :key="index"></el-option>
                  </el-select>

                </el-col>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="出库类型" prop="outType">
                <select-para v-model="formData.outType" :disabled="!showGoodsDetail" @change="selSupType" @input="selSupType" :options="supplierOptions" placeholder="请选择出库类型"></select-para>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="收货人" prop="receiver">
                <el-input v-model="formData.receiver" :disabled="!showGoodsDetail" placeholder="请填写收货人" v-if="showGoodsDetail" />
                <span v-else>{{ formData.receiver }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="mobile">
                <el-input v-model="formData.mobile" maxlength="11" placeholder="请填写联系方式" :disabled="!showGoodsDetail" v-if="showGoodsDetail" />
                <span v-else>{{ formData.mobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="物流单号" prop="transitNo">
                <el-input v-model="formData.transitNo" :disabled="!showGoodsDetail" placeholder="请填写物流单号" class="" v-if="showGoodsDetail" />
                <span v-else>{{ formData.transitNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运费" prop="transitPrice">
                <el-input v-model="formData.transitPrice" maxlength="4" placeholder="请填写运费" :disabled="!showGoodsDetail" v-if="showGoodsDetail" @blur="transitPriceBlur(formData.transitPrice)" />
                <span v-else>{{ formData.transitPrice }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="三方确认" prop="thirdFlag">
                <el-radio-group v-model="formData.thirdFlag">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="formData.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="收货地址" prop="receiveAddress">
                <el-col :span="8">
                  <el-cascader style="width: 100%" size="large" :options="options" v-model="selectedOptions" @change="handleChange" :disabled="!showGoodsDetail">
                  </el-cascader>
                  <!-- <span v-else>{{ selectedOptions }}</span> -->
                </el-col>
                <el-col :span="12">
                  <el-input v-model="formData.receiveAddress" class="w-full" placeholder="请输入详细地址" :disabled="!showGoodsDetail" v-if="showGoodsDetail" type="digit" />
                  <span v-else>{{ formData.receiveAddress }}</span>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item :label="otherTitle" v-if="isRedText" prop="foundry">
                <el-input v-if="otherTitle == '代工厂'" v-model="foundry" placeholder="请输入代工厂" />

                <el-input v-if="otherTitle == '供应商'" v-model="supplier" placeholder="请输入供应商" />

              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="firstTitle1">出库商品配置</div>
        <div class="flex m-b-20" v-if="showGoodsDetail">
          <div class="flex" style="padding: 0 10px">
            <vs-button type="border" size="small" @click.prevent="addNewGoods" class="common-btn">批量添加</vs-button>
            <vs-button type="border" size="small" @click.prevent="deleteBatchGoods" class="common-btn mar-left-8">批量删除
            </vs-button>
          </div>
        </div>
        <div style="padding: 0 10px">
          <el-table :data="goodsList" border show-summary style="width: 100%; border-radius: 4px" :summary-method="getSummaries" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column prop="id" label="序号" width="60px" align="center">
              <template slot-scope="scope">
                {{ scope.$index+1 }}
              </template>
            </el-table-column>
            <el-table-column prop="skuCode" label="商品编码" width="120">
            </el-table-column>
            <el-table-column prop="barCode" label="69码" width="160">
            </el-table-column>
            <el-table-column prop="skuName" width="300px" label="商品名称">
            </el-table-column>
            <el-table-column prop="skuSpec" label="规格"> </el-table-column>
            <el-table-column prop="actualQty" label="实际出库数量" width="120" align="center">
            </el-table-column>
            <el-table-column prop="amount" label="应出库数量" width="200" align="center">
              <template slot-scope="scope">
                <div v-if="showGoodsDetail">
                  <el-input-number size="small" @mousewheel.prevent v-model="scope.row.amount" @input="amountBlur(scope.row)" />
                </div>
                <div v-else>
                  {{ scope.row.amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="220">
              <template slot-scope="scope">
                <div v-if="showGoodsDetail">
                  <el-input v-model="scope.row.remark" type="text" placeholder="备注" />
                </div>
                <div v-else>
                  {{ scope.row.remark }}
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="60px" label="操作" v-if="showGoodsDetail">
              <template slot-scope="scope">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 stroke-current" class="ml-2 text-primary" @click="deleteGoods(scope.$index)" />
              </template>
            </el-table-column>
          </el-table>
          <div class="flex marTop18 search-add-wrap" v-if="showGoodsDetail">
            <search-input ref="bookmarkAutoSuggest" :autoFocus="true" :data="goodsOptions" :searchLimit="5" placeholder="请输入要添加的商品名或编号" inputClassses="w-full" show-action show-pinned hideGroupTitle
              background-overlay showName="skuName" @input="searchInputSuggest" @selected="selectOneGood" />
            <vs-button color="primary" type="flat" class="table-inner-btn" @click="addSuggestGood">添加</vs-button>
            <!-- <vs-button icon-pack="feather" class="common-btn addGoodsBtn"
                                @click="addSuggestGood">添加</vs-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="fix-bottom">
      <vs-button v-if="showGoodsDetail" type="filled" @click.prevent="doSaveBill" class="marLeft12">保存</vs-button>
      <vs-button type="border" @click.prevent="cancel()" class="marLeft12">
        {{ showGoodsDetail ? "取消" : "返回" }}
      </vs-button>
    </div>
    <!-- 新增商品弹窗 -->
    <vs-prompt @cancel="goodsSuggest = ''" @accept="addBillGoods()" title="选择需要添加的商品" acceptText="确认" cancelText="取消" :active.sync="showAddGoodDialog">
      <div class="con-exemple-prompt">
        <div class="flex flexStart">

           <select-para v-model="categoryId"  :options="categoryOptions" placeholder="请选择分类"></select-para>

          <el-input v-model="goodsSuggest" maxlength="200" class="marLeft20" placeholder="请输入商品编码/名称" />
          <el-button type="border" @click.prevent="getAllGoods" class="marLeft20">查询</el-button>
          <!-- <v-select v-model="categoryId" :options="categoryOptions" :reduce="(opt) => opt.id" placeholder="请选择分类">
            <div slot="no-options">暂无选项</div>
          </v-select>
          <gc-cmp-vs-input v-model="goodsSuggest" maxlength="200" class="marLeft20" placeholder="请输入商品编码/名称" />
          <vs-button type="border" @click.prevent="getAllGoods" class="marLeft20">查询</vs-button> -->
        </div>
        <gc-cmp-vs-table multiple ref="selectGoodTable" v-model="selectedGoods" :data="goodsAllList" class="marTop18">
          <template slot="thead">
            <vs-th>商品编码</vs-th>
            <vs-th>69码</vs-th>
            <vs-th>商品名称</vs-th>
            <vs-th>规格</vs-th>
            <vs-th>分类</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.skuId" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].skuCode">
                  {{ data[indextr].skuCode }}
                </vs-td>
                <vs-td :data="data[indextr].barCode">
                  {{ data[indextr].barCode }}
                </vs-td>
                <vs-td :data="data[indextr].skuName">
                  {{ data[indextr].skuName }}
                </vs-td>
                <vs-td :data="data[indextr].skuSpec">
                  {{ data[indextr].skuSpec }}
                </vs-td>
                <vs-td :data="data[indextr].categoryName">
                  {{ data[indextr].categoryName }}
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </gc-cmp-vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
import selectPara from "@/components/selectPara";

import {
  WmsWarehouseApi,
  Mod_Warehouse_Types_Options, //库存类型
} from "@/modules/server-api/wms-manage/warehouse";

import {
  WmsWarehousingApi, //接口
} from "@/modules/server-api/wms-manage/delivery";
import { WmsSupplierApi } from "@/modules/server-api/wms-manage/supplier";
import { CommodityCategoryApi } from "@/modules/server-api/commodity-sys/category-manage";
import { CommodityGoodsyApi } from "@/modules/server-api/commodity-sys/goods-manage";
import vSelect from "vue-select";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import { getThreeCategory } from "@/modules/commodity-sys/common.js";
// import Search from '@/views/pages/Search.vue';
import { validatePosNumber } from "@/utils/validateUtil.js";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";

export default {
  components: {
    vSelect,
    GcCmpVsTable,
    GcCmpVsInput,
    SearchInput,
    selectPara,
  },
  data () {
    let validate_bodyId = (rule, value, callback) => {
      if (
        !this.formData.bodyId ||
        !this.formData.wsId ||
        !this.formData.locId
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };

    let validate_receiveAddress = (rule, value, callback) => {
      if (
        this.formData.province != "香港特别行政区" &&
        this.formData.province != "澳门特别行政区" &&
        !this.formData.province
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };

    let validate_foundry1 = (rule, value, callback) => {
      if (
        this.isOutType && this.supplier == ""
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };

    return {
      foundry: "", //代工厂
      supplier: "", //供应商
      pageTitle: "",
      parentUrl: "/modules/wms/manage/delivery", //列表页链接
      formData: {
        // status: 0,
        // foundry: "",
        // supplier: "",
        // billNo: "",
        // mobile: "",
        // remark: "",
        // thirdFlag: 0,
        transitPrice: 0,
        // outType: "",
        // bodyId: "",
      },
      billId: "",
      supplierOptions: [
        { label: "拆箱出库", value: "拆箱出库" },
        { label: "按盒出库", value: "按盒出库" },
        { label: "代工组合出库", value: "代工组合出库" },
        { label: "非代工组合出库", value: "非代工组合出库" },
        // { label: "库存混货", id: "库存混货" },
        { label: "商品报废", value: "商品报废" },
        { label: "研发出库", value: "研发出库" },
        { label: "商品过期", value: "商品过期" },
        { label: "商品下架", value: "商品下架" },
        // { label: "商品质量有问题", id: "商品质量有问题" },
        { label: "商品损坏", value: "商品损坏" },
        { label: "返厂", value: "返厂" },
        { label: "其他", value: "其他" },
        // { label: "丢失", id: "LOST" },
      ],
      thirdOptions: [
        { id: "1", label: "是" },
        { id: "0", label: "否" },
      ],
      mainOptions: [], //主体选项
      distOptions: [], //分仓选项
      locOptions: [], //仓位选项
      categoryOptions: [], //分类选项
      categoryId: "",
      searchTime: 0,
      showAddGoodDialog: false,
      suggest: "",
      goodsSuggest: "",
      breadcrumb: [],
      goodsList: [],
      tempGoodsList: [],
      goodsAllList: [],
      selectedGoods: [], //已选择的商品
      showGoodsDetail: false, //是否显示新增商品按钮
      totalNum: 0,
      goodsOptions: [],
      oneGoodSelected: {},
      oneGoodSuggest: "",
      selectedListGoods: [], //列表选择的商品
      showMenuFlag: false, //是否显示下拉框
      otherTitle: "", //选择出库类型新增字段
      otherPlaceTitle: "",
      isRedText: false,
      isOutType: false,
      allText: "全部",
      otherText: "其他",
      selectedOptions: [], //选中的省市区
      options: regionData, //省市区数据

      rules: {
        bodyId: [
          {
            required: true,
            validator: validate_bodyId,
            message: "请依次选择主体,仓库,仓位",
          },
        ],
        outType: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "change",
          },
        ],
        receiver: [
          {
            required: true,
            message: "请填写收货人",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请填写手机号",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        thirdFlag: [
          {
            required: true,
            message: "请选择是否三方确认",
            trigger: "change",
          },
        ],
        receiveAddress: [
          {
            required: true,
            message: "请填写详细收货地址",
          },
          {
            validator: validate_receiveAddress,
            message: "请选择收货地址",
          },
        ],
        foundry: [
          {
            required: true,
            validator: validate_foundry1,
            message: "请填写供应商",
          },
        ]
      },
    };
  },
  mounted () {
    //初始化参数
    // this.init();
    if (this.$route.query.rowId) {
      if (this.$route.query.flag == 'edit') {
        this.showGoodsDetail = true;
        this.pageTitle = "编辑出库单";
      } else {
        this.showGoodsDetail = false;
        this.pageTitle = "查看出库单";
      }
      this.billId = this.$route.query.rowId;
      this.initData();
    } else {
      this.showGoodsDetail = true;
      this.pageTitle = "新增出库单";
    }

    this.getMainList();
  },
  methods: {
    handleSelectionChange (val) {
      this.selectedListGoods = val;
    },
    //商品合计处理
    getSummaries (param) {
      const { columns, data } = param;
      // console.log(columns, data, "=========");
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 6 || index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          // console.log(values, "values")
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            // sums[index] = 'N/A';
          }
        }
      });
      return sums;
    },

    async initData () {
      let rep = await WmsWarehousingApi.oneBill({
        id: this.billId,
      });
      if (rep.succ == 1) {
        let result = rep.result;
        this.foundry = result.outBill.foundry;
        this.supplier = result.outBill.supplier;

        result.outBill.thirdFlag = Number(result.outBill.thirdFlag);
        this.formData = result.outBill;
        this.goodsList = result.outBillDetails;
        console.log(this.formData, "formData", this.goodsList, "goodsList");

        this.selSupType(this.formData.outType);

        if (this.formData.status == 0) {
          //待出库
          this.showGoodsDetail = true;
        } else {
          //已出库
          this.showGoodsDetail = false;
        }
        if (this.formData.bodyId) {
          this.getMainOptions(this.formData.bodyId, "init");
        }
        if (this.formData.wsId) {
          this.getLocOptions(this.formData.wsId, "init");
        }

        //处理地址等信息渲染
        this.showStorageInfo();
      } else {
        this.$notifyError("获取商品失败：" + rep.error);
      }
    },

    //初始化
    async init () {
      //获取列表信息
      let rowData = JSON.parse(this.$route.query.row);
      console.log("rowData======", rowData);
      if (rowData) {
        this.formData = JSON.parse(JSON.stringify(rowData));
        this.billId = rowData.id;
        console.log("formData======", this.formData);
        this.selSupType(rowData.outType);

        if (rowData.status == 0) {
          //待出库
          this.showGoodsDetail = true;
        } else {
          //已出库
          this.showGoodsDetail = false;
        }
        if (this.formData.bodyId) {
          this.getMainOptions(this.formData.bodyId, "init");
        }
        if (this.formData.wsId) {
          this.getLocOptions(this.formData.wsId, "init");
        }
        this.getGoodsTableData();
        //处理地址等信息渲染
        this.showStorageInfo();
      } else {
        this.showGoodsDetail = true;
      }
      //菜单导航

      if (this.showGoodsDetail) {
        this.pageTitle = "新增出库单";
      } else {
        this.pageTitle = "查看出库单";
      }
      // this.breadcrumb = [
      //   {
      //     title: "出库管理",
      //     url: this.parentUrl,
      //   },
      //   {
      //     title: this.showGoodsDetail ? "新增出库单" : "查看出库单",
      //     active: true,
      //   },
      // ];
    },

    //获取主体
    async getMainList () {
      let resp = await WmsWarehouseApi.getAllMainBody({});
      console.log(resp);
      if (resp.code == 0 && resp.succ == 1) {
        let result = resp.result;
        this.mainOptions = result.map((item) => {
          let obj = {};
          obj.value = item.id;
          obj.label = item.name;
          return obj;
        });
      }
    },
    //获取分仓
    // async getDistList() {
    //   let resp = await WmsWarehouseApi.getWarehouseAll({
    //     suggest: "",
    //     type: Mod_Warehouse_Types_Options[2].id,
    //   });
    //   this.distOptions = resp.result.map((item) => {
    //     let obj = {};
    //     obj.id = item.wsId;
    //     obj.label = item.wsName;
    //     return obj;
    //   });
    // },
    //获取分仓
    async getMainOptions (id, flag) {
      console.log("id", id);
      let bodyId = id || this.formData.bodyId;
      if (bodyId == "") {
        this.$notifyError("请先选择主体");
      } else {
        let resp = await WmsWarehouseApi.getWarehouseAll({
          bodyId: bodyId,
          suggest: "",
          type: Mod_Warehouse_Types_Options[2].id,
        });
        this.distOptions = resp.result
          ? resp.result.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.wsName;
            return obj;
          })
          : [];
        if (!flag) {
          this.$set(this.formData, "wsId", "");
          this.$set(this.formData, "locId", "");
        }
      }
    },
    //获取仓位
    async getLocOptions (id, flag) {
      // this.goodsList = [];
      // this.tempGoodsList = [];
      let wsId = id || this.formData.wsId;
      if (wsId == "") {
        this.$notifyError("请先选择仓库");
      } else {
        let resp = await WmsWarehouseApi.getLocAll({
          wsId: wsId,
        });
        this.locOptions = resp.result
          ? resp.result.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.locName;
            return obj;
          })
          : [];
      }
      if (!flag) {
        this.$set(this.formData, "locId", "");
      }
    },
    locChange () {
      this.goodsList = [];
      this.tempGoodsList = [];
    },
    //获取出库类型
    selSupType (event) {
      this.formData.supplier = "";
      this.formData.foundry = "";
      console.log(event);
      let otherTitle = "",
        otherPlaceTitle = "",
        isRedText = false,
        isOutType = false;
      switch (event) {
        case "返厂":
          otherTitle = "供应商";
          otherPlaceTitle = "请输入供应商";
          isRedText = true;
          isOutType = true;
          break;
        case "代工组合出库":
          otherTitle = "代工厂";
          otherPlaceTitle = "请输入代工厂";
          // isRedText = false;
          isRedText = true;
          isOutType = false;
      }
      this.otherTitle = otherTitle;
      this.otherPlaceTitle = otherPlaceTitle;
      this.isRedText = isRedText;
      this.isOutType = isOutType;
    },
    //省市区联动信息处理
    handleChange (addressArr) {
      if (addressArr.length > 0) {
        this.formData.province = CodeToText[addressArr[0]];
        this.formData.city = CodeToText[addressArr[1]];
        let currArea = CodeToText[addressArr[2]]
          ? CodeToText[addressArr[2]] == this.allText
            ? this.otherText
            : CodeToText[addressArr[2]]
          : "";
        this.formData.area = currArea;
        console.log("地址信息", this.formData);
      }
    },
    //地址信息渲染
    showStorageInfo () {
      //地址信息
      console.log("this.formData.province", this.formData);
      if (this.formData.province != "") {
        let currArea = this.formData.area
          ? this.formData.area == this.otherText
            ? this.allText
            : this.formData.area
          : "";
        // console.log('==this.formData==', this.formData.);
        let currAddressCode = currArea
          ? TextToCode[this.formData.province][this.formData.city][currArea]
            .code
          : TextToCode[this.formData.province][this.formData.city].code;
        console.log("currAddressCode收货地址信息", currAddressCode);
        this.selectedOptions = currAddressCode;
      }
    },
    //获取分类
    async getCategoryList () {
      this.categoryOptions = [];
      let resp = await CommodityCategoryApi.getCategoryList({});
      let resList = resp.result;
      if (resList) {
        //获取三级分类
        let finalList = [];
        resList.map((item) => {
          let child = getThreeCategory(item);
          if (child && child.length > 0) {
            child.map((item) => finalList.push(item));
          }
        });
        finalList &&
          finalList.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.categoryName;
            this.categoryOptions.push(obj);
          });
          this.categoryOptions = JSON.parse(JSON.stringify(this.categoryOptions))
      }
    },
    //获取商品列表
    async getGoodsTableData () {
      //根据入库单获取商品
      this.totalNum = 0;
      if (this.billId) {
        let rep = await WmsWarehousingApi.oneBill({
          id: this.billId,
          suggest: this.goodsSuggest,
        });
        if (rep.succ == 1) {
          let resList = rep.result.details;
          this.goodsList = resList;
          this.tempGoodsList = resList;
        } else {
          this.$notifyError("获取商品失败：" + rep.error);
        }
      } else {
        this.$notifyError("获取出库单id失败");
      }
    },
    //新增商品
    async addNewGoods () {
      console.log("this.formData", this.formData);
      if (this.formData.wsId && this.formData.locId) {
        //获取分类
        this.getCategoryList();
        this.goodsSuggest = "";
        this.categoryId = "";
        this.showAddGoodDialog = true;
        this.selectedGoods = [];
        //获取商品列表
        this.getAllGoods();
      } else {
        this.$notifyError("请输入出库仓库和仓位");
      }
    },
    //获取所有商品
    async getAllGoods () {
      let param = {};
      param.suggest = this.goodsSuggest;
      if (this.categoryId != "") {
        param.categoryId = this.categoryId;
      }
      param.storeId = this.formData.wsId;
      param.locId = this.formData.locId;
      let resp = await CommodityGoodsyApi.getSkuStocks(param);
      let resList = resp.result;
      this.goodsAllList = resList;
      this.goodsAllList = resList.filter((item) => {
        let exists = false;
        if (this.tempGoodsList.length > 0) {
          this.tempGoodsList.map((good) => {
            if (good.skuId == item.skuId) {
              exists = true;
            }
          });
        }

        if (!exists) {
          //格式化规格
          // item.skuId = item.id;
          return item;
        }
      });
      // if(this.goodsAllList.length > 0){
      //   //清空选择对象
      //   let currSelectGoods = this.selectedGoods;
      //   this.$refs['selectGoodTable'].onlyClickCheckbox = false;
      //   this.goodsAllList.map(item => {
      //     //如果已经选中需要默认选择
      //       let selectIndex = currSelectGoods.findIndex(v =>  v.skuId === item.skuId)
      //       if(selectIndex !== -1) {
      //         this.handleGoodsSelected(item);
      //       }
      //   })
      // }
    },
    _uniqueArr (array, id) {
      var result = [];
      var obj = {};
      for (let i = 0; i < array.length; i++) {
        if (!obj[array[i][id]]) {
          result.push(array[i]);
          obj[array[i][id]] = true;
        }
      }
      return result;
    },
    //模糊搜索新增商品
    addSuggestGood () {
      if (Object.keys(this.oneGoodSelected).length == 0) {
        this.$notifyError("请选择要新增的商品");
      } else {
        //设置入库数量及备注默认值
        // this.oneGoodSelected.skuId = this.oneGoodSelected.skuId;

        // 做过滤
        const isRepeat = this.goodsList.findIndex(
          (v) => v.skuId === this.oneGoodSelected.skuId
        );
        if (isRepeat !== -1) {
          this.$set(
            this.goodsList[isRepeat],
            "amount",
            ++this.goodsList[isRepeat].amount
          );
          this.oneGoodSelected = "";
        } else {
          this.goodsList.unshift({
            ...this.oneGoodSelected,
            amount: 1,
          });

          this.tempGoodsList.unshift({
            ...this.oneGoodSelected,
            amount: 1,
          });
          this.oneGoodSelected = "";
        }
      }
      // if (Object.keys(this.oneGoodSelected).length == 0) {
      //   this.$notifyError("请选择要新增的商品");
      // } else {
      //   //设置入库数量及备注默认值
      //   this.oneGoodSelected.skuId = this.oneGoodSelected.id;
      //   //this.oneGoodSelected.skuName = this.oneGoodSelected.goodsName;
      //   this.goodsList.push({...this.oneGoodSelected, amount:1});
      //   this.tempGoodsList.push({...this.oneGoodSelected, amount:1});
      // }
    },
    //选择单件商品
    selectOneGood (item) {
      console.log("===selectOneGood===");
      console.log(item);
      this.oneGoodSelected = item;
      //选择并添加
      this.addSuggestGood();
    },
    //查询列表
    searchGoods () {
      if (this.suggest == "") {
        this.goodsList = this.tempGoodsList;
      } else {
        this.goodsList = this.tempGoodsList.filter((item) => {
          if (
            (item.skuCode && item.skuCode.indexOf(this.suggest) > -1) ||
            (item.skuName && item.skuName.indexOf(this.suggest) > -1) ||
            (item.barCode && item.barCode.indexOf(this.suggest) > -1)
          ) {
            return item;
          }
        });
      }
    },
    cancelGood () {
      this.goodsSuggest = "";
    },
    //保存新增的商品
    addBillGoods () {
      if (this.goodsAllList.length > 0) {
        //去重
        //let uniqueId = 'skuId';
        //this.selectedGoods = this._uniqueArr(this.selectedGoods, uniqueId);
        // this.$refs['selectGoodTable'].value = this._uniqueArr(this.$refs['selectGoodTable'].value, uniqueId);
        if (this.selectedGoods.length > 0) {
          this.totalNum = 0;
          this.selectedGoods.map((item) => {
            this.goodsList.unshift({ ...item, amount: 1 });
            this.tempGoodsList.unshift({ ...item, amount: 1 });
          });
        }
      } else {
        console.log("this.totalNum", this.totalNum);
        //  this.$notifyError("暂无商品请重新选择");
      }
    },
    //仅前台删除
    deleteGoods (index) {
      this.goodsList = this.goodsList.filter((item, idx) => idx != index);
      this.tempGoodsList = this.tempGoodsList.filter(
        (item, idx) => idx != index
      );
    },
    //批量删除
    deleteBatchGoods () {
      if (this.selectedListGoods.length == 0) {
        this.$notifyError("请先选择要删除的商品");
      } else {
        this.goodsList = this.goodsList.filter((item) => {
          let delFlag = false;
          this.selectedListGoods.map((sel) => {
            if (sel.skuId == item.skuId) {
              delFlag = true;
            }
          });
          if (!delFlag) {
            return item;
          }
        });

        this.tempGoodsList = this.tempGoodsList.filter((item) => {
          let delFlag = false;
          this.selectedListGoods.map((sel) => {
            if (sel.skuId == item.skuId) {
              delFlag = true;
            }
          });
          if (!delFlag) {
            return item;
          }
        });
        this.selectedListGoods = [];
      }
    },
    //弹窗内部搜索回显
    async handleGoodsSelected (tr) {
      this.$refs["selectGoodTable"].clicktr(tr, true);
      this.$refs["selectGoodTable"].value.push(tr);
      const currIndex = this.$refs["selectGoodTable"].value.findIndex(
        (v) => v.skuId === tr.skuId
      );
      if (currIndex !== -1) {
        this.$refs["selectGoodTable"].value.push(tr);
      }
    },
    //保存校验
    validate () {
      let validateItem = [
        "wsId",
        "locId",
        "outType",
        "receiver",
        "receiveAddress",
        "thirdFlag",
        "province",
        "city",
      ];
      if (this.isOutType) {
        validateItem.push("supplier");
      }
      if (
        this.formData.province != "香港特别行政区" &&
        this.formData.province != "澳门特别行政区"
      ) {
        validateItem.push("area");
      } else {
        this.formData.area = "";
      }
      var pattern = /^1{1}[0-9]{10}$/;
      if (this.formData.mobile == "") {
        this.$notifyError("请输入手机号!");
        return false;
      } else if (this.formData.mobile.split("").length != 11) {
        this.$notifyError("请输入11位手机号！");
        return;
      } else {
        if (!pattern.test(this.formData.mobile)) {
          this.$notifyError("请输入正确的手机号！");
          return false;
        }
      }
      let passFlag = true;
      validateItem.map((item) => {
        if (passFlag) {
          if (!this.formData[item] || this.formData[item] == "") {
            passFlag = false;
          }
        }
      });
      return passFlag;
    },
    //执行保存
    async doSaveBill () {
      //校验
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.totalNum == 0) {
            this.$notifyError("出库数量不能为0，请添加商品");
          } else {
            let param = this.formData;
            param.supplier = this.supplier;
            param.foundry = this.foundry;
            if (this.goodsList.length > 0) {
              // console.log("this.tempGoodsList", this.tempGoodsList);
              // param["details"] = this.tempGoodsList;
              param["details"] = this.goodsList;
            }
            WmsWarehousingApi.saveBill(this.formData).then((rep) => {
              if (rep.succ == 1) {
                this.$notifySuccess("保存成功");
                //刷新页面
                this.goParentPage();
              } else {
                this.$notifyError("保存失败：" + rep.error);
              }
            });
          }
        }
      });

    },
    cancel () {
      // 如果是编辑-提示弹框
      this.$vs.dialog({
        type: "confirm",
        title: `请确认`,
        text: `是否确认取消`,
        acceptText: "确认",
        cancelText: "取消",
        accept: () => {
          sessionStorage.removeItem("row");
          this.$router.push({ path: this.parentUrl }).catch(() => { });
        },
      });
    },
    //返回父级
    goParentPage () {
      sessionStorage.removeItem("row");
      this.$router.push({ path: this.parentUrl }).catch(() => { });
    },
    //模糊搜索获取sku信息
    async searchInputSuggest (value) {
      if (this.formData.wsId || this.formData.locId) {
        if (this.value != "") {
          let param = {};
          let thisSearchTime = new Date().getTime();
          this.searchTime = thisSearchTime;
          param.suggest = value;
          // if (this.categoryId != "") {
          //   param.categoryId = value;
          // }
          param.storeId = this.formData.wsId;
          param.locId = this.formData.locId;
          let res = await CommodityGoodsyApi.getSkuStocks(param);

          // let res = await CommodityGoodsyApi.suggestSkuGoods({ key: value });
          if (thisSearchTime >= this.searchTime) {
            this.goodsOptions = res.result;
          }
          this.$forceUpdate();
        }
      } else {
        this.$refs["bookmarkAutoSuggest"].searchQuery = "";
        this.$notifyError("请先选择输入出库仓库和仓位");
      }
    },
    //出库数量
    amountBlur (data) {
      if (data.amount == "" && data.amountQty == 0) {
        data.amount = 0;
      }
    },
    transitPriceBlur (num) {
      // console.log('num',num)
      // if(num < 0) {
      //     this.$notifyError("请填写正确的运费数");
      //     this.formData.transitPrice = '';
      // }
      if (this.formData.transitPrice != "" && !validatePosNumber(num)) {
        this.formData.transitPrice = "";
        this.$notifyError("请填写正确的运费数");
      }
    },
  },

  watch: {
    goodsList: {
      handler (newVal, oldVal) {
        console.log(newVal, "=========newVal")
        this.totalNum = 0;
        if (this.goodsList.length > 0) {
          this.goodsList.map((item) => {
            this.totalNum += parseInt(item.amount) || 0;
            //修改tempGoodsList
            this.tempGoodsList = this.tempGoodsList.map((temp) => {
              if (item.skuId == temp.skuId) {
                temp = item;
              }
              return temp;
            });
          });
          this.totalNum = parseInt(this.totalNum);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/modules/commodity-sys/commodity.scss';

  .firstTitle1 {
    height: 50px;
    line-height: 50px;
    color: #5e5873;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }

  .el-form {
    padding: 0 10px;
  }

  .center-num {
    text-align: center;

    /deep/ .vs-table-text {
      text-align: center;
      justify-content: center;
    }
  }

  .common-wrap {
    padding: 0 24px 24px;

    &.white {
      background-color: #fff;
      padding: 0 24px 100px;
    }
  }

  .base-wrap {
    padding: 0 24px;
  }

  .vs-row {
    margin-bottom: 20px;

    .vs-col {
      align-items: center;

      .redText {
        margin-right: 8px;
      }

      &.colTitle {
        justify-content: flex-end;
        margin-right: 16px;
      }
    }
  }

  // 表单
  .vs-input,
  .v-select {
    width: 200px;
    height: 38px;
    line-height: 19px;
  }

  .width200 {
    width: 200px;
  }

  .small-select /deep/ .vs__selected {
    max-width: 163px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .v-select {
    width: 195px;
  }

  .form-label {
    width: 70px;
    text-align: left;
  }

  .marTop40 {
    margin-top: 40px;
  }

  .common-btn {
    height: 38px;
    margin-left: 0;
    font-size: 14px;
  }

  .addGoodsBtn {
    width: 97px;
    margin-left: -5px;
    z-index: 1000;
  }

  .addBatchGoodsBtn {
    width: 126px;
  }

  .fix-bottom {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 11px 0;
    background-color: #f8f8f8;
    z-index: 1000;
  }

  .search-btn {
    height: 38px;
    line-height: 38px;
  }

  #edit-table /deep/ .vs-con-tbody {
    width: 1300px;
    overflow: auto;
  }

  .mar-left-8 {
    margin-left: 8px;
  }

  .search-add-wrap {
    position: relative;

    .table-inner-btn {
      position: absolute;
      right: 0;
      font-size: 14px;
      z-index: 1000;
    }
  }
</style>